import EmptyState from "ds/components/EmptyState";
import { EmptystateLinkColored } from "components/icons/generated";
import Box from "ds/components/Box";

const ManageSlackAccessEmpty = () => {
  return (
    <Box align="center" justify="center" grow="1">
      <EmptyState
        title="You don't have any accesses yet"
        icon={EmptystateLinkColored}
        caption="Click on Grant access button to add one."
      />
    </Box>
  );
};

export default ManageSlackAccessEmpty;
